/* eslint-disable @typescript-eslint/no-explicit-any */

type SuspenseProps<T> = {
	query: () => Promise<T>;
	onLoaded: (data: T) => HTMLElement;
	onError?: (error: any) => HTMLElement;
	fallback?: HTMLElement;
};
export function Suspense<T>({ query, onLoaded, onError, fallback }: SuspenseProps<T>) {
	fallback ??= (<span class="fade-in">loading....</span>) as HTMLElement;
	onError ??= () => <span>Failed to load.</span>;

	const replaceContent = (content: HTMLElement) => {
		fallback.parentElement?.insertBefore(content, fallback);
		fallback.remove();
	};

	query()
		.then((data) => {
			const content = onLoaded(data);
			replaceContent(content);
		})
		.catch((e) => {
			console.log('got suspense error', e);
			const content = onError(e);
			console.error(e);
			replaceContent(content);
		});
	return fallback;
}
